import { AppleIcloudIcon } from './AppleIcloudIcon';

/**
 * author: Contributors
 * id BDB8AF3D-28BD-4FF2-AED0-36108C1B0543
 * name apple-icloud
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/apple-icloud.svg
 * tags
 * - Brand / Logo 
 */
export const AppleMobilemeIcon = AppleIcloudIcon;
export default AppleMobilemeIcon